enum FloorTypeOptions {
  LOW = "Baixo",
  MEDIUM = "Intermediário",
  HIGH = "Alto",
}

export default FloorTypeOptions;
